import React, { useState, useEffect } from "react";
import { cloneDeep } from "lodash";

import { useTranslation } from "react-i18next";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";

function EguSelfInspectionWareHouseMoveButton(props) {
    const { t } = useTranslation();

    const { id, schema, grid, refresh, onSuccess, modifyUrlCallback, customizeErrorMsgCallback, ...others } = props;

    const [modifiedSchema, setModifiedSchema] = useState();

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();

    useEffect(() => {
        let modifiedSchema = cloneDeep(schema);

        if (modifiedSchema) {
            for (const column of modifiedSchema.columns) {
                switch (column.name) {
                    case "wareHouseCode":
                        column.hideInForm = false;
                        column.disabled = false;
                        column.required = true;
                        break;

                    default:
                        column.disabled = true;
                        column.required = false;
                        break;
                }
            }

            setModifiedSchema(modifiedSchema);
        }
    }, [schema]);

    const onOpen = () => {
        if (grid) {
            setFormData({ ...grid.selectedItems[0] });
        }

        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onWareHouseMoveSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        refresh.refresh();
    };

    return (
        <React.Fragment>
            <ActionButtonLayout id={`${id}-warehouse-move-button`} onClick={onOpen} {...others}>
                {t("buttonName.MoveLot")}
            </ActionButtonLayout>
            <AutoFormDialog
                id={id + "warehouse-move-dialog"}
                mode="edit"
                formId={id + "warehouse-move-form"}
                title={schema ? t(`dialog.title.${schema.name}.moveLot`) : ""}
                schema={modifiedSchema}
                initialData={formData}
                modifyUrlCallback={modifyUrlCallback}
                open={open}
                onClose={onClose}
                onSuccess={onWareHouseMoveSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </React.Fragment>
    );
}

export default EguSelfInspectionWareHouseMoveButton;
